import { Alert, Select, Spin } from 'antd';
import Link from 'antd/es/typography/Link';
import React, { useMemo } from 'react';
import { useUserOptions } from 'src/api/user';
import { showFormModalAntd } from 'src/components/show-modal-antd';
import { FormItem } from 'src/shared/form-utils';
import { apiFetch } from 'src/shared/web-api-utils';
import { sleepForever } from 'src/utils';

interface AccountOptions {
  language: string;
}

function AccountModalContent() {
  const [userOptions] = useUserOptions();
  const options = useMemo(() => {
    return userOptions?.languages
      .map((l) => ({
        value: l,
        key: l,
        label: (Intl?.DisplayNames && new Intl.DisplayNames([l], { type: 'language' }).of(l)) || l,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [!!userOptions]);
  return (
    <Spin spinning={!userOptions}>
      <FormItem initialValue={userOptions?.language} name="language" label={UiText.t('User_DisplayLanguage_Text')} required>
        <Select virtual={false} options={options} />
      </FormItem>
      <Alert
        type="info"
        id="oidcNotice"
        message={
          <>
            {UiText.t('User_FederatedLoginAccountNotice_Hint') + ' '}
            <Link target="_blank" href={userOptions?.userAccountUrl}>
              {UiText.t('User_FederatedLoginExternalAccount_Link')}
            </Link>
            .
          </>
        }
      />
    </Spin>
  );
}

async function showAccountModal() {
  await showFormModalAntd<AccountOptions>('account', UiText.t('User_AccountSettings_Header'), <AccountModalContent />, {
    okButtonText: UiText.t('Shared_SaveChanges_Button'),
    onConfirm: async ({ language }) => {
      await apiFetch('user/options', {
        method: 'PATCH',
        body: JSON.stringify({ language }),
        headers: { 'Content-Type': 'application/json' },
      });
      window.location.reload();
      await sleepForever();
    },
  });
}

export function init(link: HTMLAnchorElement) {
  link.addEventListener('click', (e) => {
    showAccountModal();
    e.preventDefault();
  });
}
